import { render, staticRenderFns } from "./SummitHome.vue?vue&type=template&id=133ab0b1&"
import script from "./SummitHome.vue?vue&type=script&lang=js&"
export * from "./SummitHome.vue?vue&type=script&lang=js&"
import style0 from "./SummitHome.vue?vue&type=style&index=0&id=133ab0b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports